export default __webpack_public_path__ + "static/media/forestly-noexpl-04_DE.61bef104.png";